import {createFeatureSelector, createSelector} from '@ngrx/store';
import {ListInputItem} from '../../shared/sopi-list/sopi-list.model';
import {ModuleState, PageState} from './qs-checks.reducer';
import {Funktionsbereich, FunktionsbereichPruefplaene, FunktionsbereichRolle} from '../../../clients/qschecks';

/**
 * The createFeatureSelector function selects a piece of state from the root of the state object.
 * This is used for selecting feature states that are loaded eagerly or lazily.
 */
export const getModuleState = createFeatureSelector<ModuleState>('QsChecksPage');
export const getPageState = createSelector(getModuleState, (state: ModuleState) => state.page);

// PRUEFPLAN

export const getPruefplaeneListeOriginal = createSelector(getPageState, (state: PageState) => {
    if (state.pruefplaeneListe === null || state.pruefplaeneListe === undefined) {
        return [];
    } else {
        return state.pruefplaeneListe;
    }
});

export const getPruefplaeneListe = createSelector(getPageState, (state: PageState) => {
    if (state.pruefplaeneListe === null || state.pruefplaeneListe === undefined) {
        return [];
    } else {
        const res: Array<ListInputItem> = [];
        state.pruefplaeneListe.forEach((fb) => {
            if (fb.pruefplan_liste.length > 0) {
                fb.pruefplan_liste.forEach(pp => {
                    res.push(<ListInputItem>{
                        groupId: fb.funktionsbereich.funktionsbereich_id,
                        groupTitle: fb.funktionsbereich.titel,
                        group: fb.funktionsbereich,
                        groupClass: 'funktionsbereiche',
                        itemId: pp.pruefplan_id,
                        itemTitle: pp.titel,
                        item: {pruefplan: pp, funktionsbereich: fb.funktionsbereich}
                    });
                });
            } else {
                res.push(<ListInputItem>{
                    groupId: fb.funktionsbereich.funktionsbereich_id,
                    groupTitle: fb.funktionsbereich.titel,
                    group: fb.funktionsbereich,
                    groupClass: 'funktionsbereiche',
                    itemId: null,
                    itemTitle: null,
                    item: null
                });
            }
        });
        return res;
    }
});

export const getPruefplaeneListeLaden = createSelector(getPageState, (state: PageState) => state.pruefplaeneListeLaden);
export const getPruefplaeneListeFehler = createSelector(getPageState, (state: PageState) => state.pruefplaeneListeFehler);

export const getPruefplanSelektiert = createSelector(getPageState, (state: PageState) => state.pruefplanSelektiert);
export const getPruefplanAktuell = createSelector(getPageState, (state: PageState) => state.pruefplanAktuell);
export const getPruefplanAktuellLaden = createSelector(getPageState, (state: PageState) => state.pruefplanAktuellLaden);
export const getPruefplanAktuellFehler = createSelector(getPageState, (state: PageState) => state.pruefplanAktuellFehler);

export const getAktuellenFunktionsbereich = createSelector(getPageState, (state: PageState): Funktionsbereich => {
    if (state.pruefplaeneListe === null || state.pruefplaeneListe.length === 0 || state.pruefplanSelektiert === null) {
        return null;
    } else {
        let funktionsbereich: Funktionsbereich = null;
        const index = state.pruefplaeneListe.findIndex(x => x.funktionsbereich !== null && x.funktionsbereich.funktionsbereich_id === state.pruefplanSelektiert.funktionsbereich_id);
        if (index > -1) {
            funktionsbereich = state.pruefplaeneListe[index].funktionsbereich;
        }
        return funktionsbereich;
    }
});

export const getFunktionsbereicheIds = createSelector(getPruefplaeneListeOriginal, (funktionsbereichePruefplaene: Array<FunktionsbereichPruefplaene>) => {
    return funktionsbereichePruefplaene.map(x => x.funktionsbereich.funktionsbereich_id);
});

export const getFunktionsbereichePruefplaeneIds = createSelector(getFunktionsbereicheIds, getPruefplaeneListeOriginal,
    (funktionsbereicheIds: Array<string>, funktionsbereichePruefplaene: Array<FunktionsbereichPruefplaene>) => {
    const funktionsbereichePruefplaeneIds = funktionsbereicheIds;
        funktionsbereichePruefplaene.forEach(x => {
        x.pruefplan_liste.forEach(pp => funktionsbereichePruefplaeneIds.push(pp.pruefplan_id));
    });

    return funktionsbereichePruefplaeneIds;
});

export const getPruefplanAntwortenListe = createSelector(getPageState, (state: PageState) => {
    if (state.pruefplanAntwortenListe === null || state.pruefplanAntwortenListe === undefined) {
        return [];
    } else {
        const res: Array<ListInputItem> = [];
        state.pruefplanAntwortenListe.forEach((item) => {
            res.push(<ListInputItem>{
                groupId: '',
                groupTitle: '',
                group: '',
                itemId: item.antwort_id,
                itemTitle: item.kuerzel,
                item: item
            });
        });
        return res;
    }
});

export const getPruefplanAntwortenListeLaden = createSelector(getPageState, (state: PageState) => state.pruefplanAntwortenListeLaden);
export const getPruefplanAntwortenListeFehler = createSelector(getPageState, (state: PageState) => state.pruefplanAntwortenListeFehler);

export const getPruefplanAntwortSelektiert = createSelector(getPageState, (state: PageState) => state.pruefplanAntwortSelektiert);
export const getPruefplanAntwortAktuell = createSelector(getPageState, (state: PageState) => state.pruefplanAntwortAktuell);
export const getPruefplanAntwortAktuellLaden = createSelector(getPageState, (state: PageState) => state.pruefplanAntwortAktuellLaden);
export const getPruefplanAntwortAktuellFehler = createSelector(getPageState, (state: PageState) => state.pruefplanAntwortAktuellFehler);

// PRUEFOBJEKT
export const getPruefobjekteListe = createSelector(getPageState, (state: PageState) => {
    if (state.pruefobjekteListe === null || state.pruefobjekteListe === undefined) {
        return [];
    } else {
        const res: Array<ListInputItem> = [];
        state.pruefobjekteListe.forEach((item) => {
            res.push(<ListInputItem>{
                groupId: '',
                groupTitle: '',
                group: '',
                itemId: item.pruefobjekt_id,
                itemTitle: item.titel,
                item: item
            });
        });
        return res;
    }
});

export const getPruefobjekteListeLaden = createSelector(getPageState, (state: PageState) => state.pruefobjekteListeLaden);
export const getPruefobjekteListeFehler = createSelector(getPageState, (state: PageState) => state.pruefobjekteListeFehler);

export const getPruefobjektSelektiert = createSelector(getPageState, (state: PageState) => state.pruefobjektSelektiert);
export const getPruefobjektAktuell = createSelector(getPageState, (state: PageState) => state.pruefobjektAktuell);
export const getPruefobjektAktuellLaden = createSelector(getPageState, (state: PageState) => state.pruefobjektAktuellLaden);
export const getPruefobjektAktuellFehler = createSelector(getPageState, (state: PageState) => state.pruefobjektAktuellFehler);


// PRUEF-CHECKLISTE
export const getPruefChecklistenListe = createSelector(getPageState, (state: PageState) => {
    if (state.pruefChecklistenListe === null || state.pruefChecklistenListe === undefined) {
        return [];
    } else {
        const res: Array<ListInputItem> = [];
        state.pruefChecklistenListe.forEach((item) => {
            res.push(<ListInputItem>{
                groupId: '',
                groupTitle: '',
                group: '',
                itemId: item.pruefcheckliste_id,
                itemTitle: item.titel,
                item: item,
                cdkDragData: {item: item, model: 'Pruefcheckliste'}
            });
        });
        return res;
    }
});

export const getPruefChecklistenListeLaden = createSelector(getPageState, (state: PageState) => state.pruefChecklistenListeLaden);
export const getPruefChecklistenListeFehler = createSelector(getPageState, (state: PageState) => state.pruefChecklistenListeFehler);

export const getPruefChecklisteSelektiert = createSelector(getPageState, (state: PageState) => state.pruefChecklisteSelektiert);
export const getPruefChecklisteAktuell = createSelector(getPageState, (state: PageState) => state.pruefChecklisteAktuell);
export const getPruefChecklisteAktuellLaden = createSelector(getPageState, (state: PageState) => state.pruefChecklisteAktuellLaden);
export const getPruefChecklisteAktuellFehler = createSelector(getPageState, (state: PageState) => state.pruefChecklisteAktuellFehler);

export const getPruefChecklistenIds = createSelector(getPruefChecklistenListe, (listInputItems: Array<ListInputItem>) => {
    return listInputItems.filter(item => item.itemId).map(item => item.itemId);
});

// PRUEF-AUFGABEN
export const getPruefAufgabenListe = createSelector(getPageState, (state: PageState) => {
    if (state.pruefAufgabenListe === null || state.pruefAufgabenListe === undefined) {
        return [];
    } else {
        const res: Array<ListInputItem> = [];
        state.pruefAufgabenListe.forEach((item) => {
            res.push(<ListInputItem>{
                groupId: '',
                groupTitle: '',
                group: '',
                itemId: item.pruefaufgabe_id,
                itemTitle: item.titel,
                item: item,
                cdkDragData: {item: item, model: 'Pruefaufgabe'}
            });
        });
        return res;
    }
});

export const getPruefAufgabenListeLaden = createSelector(getPageState, (state: PageState) => state.pruefAufgabenListeLaden);
export const getPruefAufgabenListeFehler = createSelector(getPageState, (state: PageState) => state.pruefAufgabenListeFehler);

export const getPruefAufgabeSelektiert = createSelector(getPageState, (state: PageState) => state.pruefAufgabeSelektiert);
export const getPruefAufgabeAktuell = createSelector(getPageState, (state: PageState) => state.pruefAufgabeAktuell);
export const getPruefAufgabeAktuellLaden = createSelector(getPageState, (state: PageState) => state.pruefAufgabeAktuellLaden);
export const getPruefAufgabeAktuellFehler = createSelector(getPageState, (state: PageState) => state.pruefAufgabeAktuellFehler);

export const getPruefAufgabenIds = createSelector(getPruefAufgabenListe, (listInputItems: Array<ListInputItem>) => {
    return listInputItems.filter(item => item.itemId).map(item => item.itemId);
});

// ROLLEN/BERECHTIGUNGEN
export const getQsPrueferRollenLoeschenAktiv = createSelector(getPageState, (state: PageState) => state.qsPrueferRollenSelected.length > 0);
export const getQsPrueferRollenSelected = createSelector(getPageState, (state: PageState) => state.qsPrueferRollenSelected);
export const getQsPrueferRollen = createSelector(getPageState, (state: PageState) => {
    if (state.qsPrueferRollen === null || state.qsPrueferRollen === undefined) {
        return [];
    }
    return state.qsPrueferRollen.map((item: FunktionsbereichRolle) => <ListInputItem>{
        groupId: '',
        groupTitle: '',
        itemId: item.rolle.rolle_id,
        itemTitle: item.rolle.titel + ' (' + item.funktionsbereich.titel + ')',
        item: item
    });
});
export const getQsPrueferRollenLaden = createSelector(getPageState, (state: PageState) => state.qsPrueferRollenLaden);
export const getQsPrueferRollenFehler = createSelector(getPageState, (state: PageState) => state.qsPrueferRollenFehler);

export const getQsControllerRollenLoeschenAktiv = createSelector(getPageState, (state: PageState) => state.qsControllerRollenSelected.length > 0);
export const getQsControllerRollenSelected = createSelector(getPageState, (state: PageState) => state.qsControllerRollenSelected);
export const getQsControllerRollen = createSelector(getPageState, (state: PageState) => {
    if (state.qsControllerRollen === null || state.qsControllerRollen === undefined) {
        return [];
    }
    return state.qsControllerRollen.map((item: FunktionsbereichRolle) => <ListInputItem>{
        groupId: '',
        groupTitle: '',
        itemId: item.rolle.rolle_id,
        itemTitle: item.rolle.titel + ' (' + item.funktionsbereich.titel + ')',
        item: item
    });
});
export const getQsControllerRollenLaden = createSelector(getPageState, (state: PageState) => state.qsControllerRollenLaden);
export const getQsControllerRollenFehler = createSelector(getPageState, (state: PageState) => state.qsControllerRollenFehler);
